import ViajeroBooking from './ViajeroBooking';

export default ViajeroBooking;
